import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { injectIymcsMark } from '../utils/richText';
import { withIymcsMark } from './IymcsMark';
import '../styles/faq_preview.css';

const renderFaqAnswer = (answer) => {
  if (!answer) return '';
  const html = /<[a-z][\s\S]*>/i.test(answer)
    ? DOMPurify.sanitize(answer)
    : answer.split('\n').filter(l => l.trim()).map(l => `<p>${l}</p>`).join('');
  return injectIymcsMark(html);
};

const FaqPreview = ({ faqItems, category, faqPath }) => {
  const items = faqItems.filter(i => i.category === category || i.category === 'general');
  const [active, setActive] = useState(0);
  const [trackHeight, setTrackHeight] = useState(0);
  const timerRef = useRef(null);
  const cardRefs = useRef([]);

  // Measure tallest card after render
  useEffect(() => {
    if (cardRefs.current.length === 0) return;
    const max = cardRefs.current.reduce((m, el) => {
      if (!el) return m;
      return Math.max(m, el.scrollHeight);
    }, 0);
    if (max > 0) setTrackHeight(max);
  }, [items.length]);

  const pausedRef = useRef(false);

  const resetTimer = (nextIdx) => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      if (!pausedRef.current) setActive(prev => (prev + 1) % items.length);
    }, 7000);
    if (nextIdx !== undefined) setActive(nextIdx);
  };

  useEffect(() => {
    if (items.length < 2) return;
    timerRef.current = setInterval(() => {
      if (!pausedRef.current) setActive(prev => (prev + 1) % items.length);
    }, 7000);
    return () => clearInterval(timerRef.current);
  }, [items.length]);

  if (items.length === 0) return null;

  return (
    <section className="faq-preview-section">
      <h2>Частые вопросы</h2>
      <Link
        to={faqPath}
        className="faq-carousel-wrap"
        onMouseEnter={() => { pausedRef.current = true; }}
        onMouseLeave={() => { pausedRef.current = false; }}
      >
        <div className="faq-carousel-track" style={trackHeight ? { height: trackHeight } : {}}>
          {items.map((item, idx) => (
            <div
              key={item.id}
              ref={el => cardRefs.current[idx] = el}
              className={`faq-carousel-card ${idx === active ? 'active' : ''}`}
            >
              <div className="faq-carousel-q">{withIymcsMark(item.question)}</div>
              <div className="faq-carousel-a" dangerouslySetInnerHTML={{ __html: renderFaqAnswer(item.answer) }} />
            </div>
          ))}
        </div>

        {items.length > 1 && (
          <div className="faq-carousel-dots" onClick={e => e.preventDefault()}>
            {items.map((_, idx) => (
              <button
                key={idx}
                className={`faq-dot ${idx === active ? 'active' : ''}`}
                onClick={e => { e.preventDefault(); resetTimer(idx); }}
                aria-label={`Вопрос ${idx + 1}`}
              />
            ))}
          </div>
        )}

        <div className="faq-carousel-cta">
          Все вопросы и ответы →
        </div>
      </Link>
    </section>
  );
};

export default FaqPreview;
